import React, {Component} from 'react'
import {connect} from 'react-redux'
import {FormError} from '../shared/FormError'
import {bindActionCreators} from 'redux'
import {Form, FormGroup, FormControl, Row, Col} from 'react-bootstrap'
import '../stylesheets/App.css'
import {actions, selectors} from '../sagas/session'

class LoginForm extends Component {
  constructor(props) {
    super(props)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentWillMount() {
    this.props.checkForSessionKey()
  }

  onSubmit(e) {
    e.preventDefault()
    const email = e.target.elements.namedItem('email').value
    const password = e.target.elements.namedItem('password').value
    this.props.login(email, password)
  }

  render() {
    this.props.logout ? this.props.destroySession() : null
    return (
      <div>
        {this.props.errors && Object.keys(this.props.errors).length > 0 && <FormError errors={this.props.errors} />}
        <Form onSubmit={this.onSubmit} >
          <Row>
            <Col xs={3} />
            <Col
              xs={6}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <FormGroup
                className='form-field km-formgroup'
                controlId='formHorizontalEmail'>
                <FormControl
                  name='email'
                  className='km-login km-field'
                  type='email'
                  placeholder='Email' />
              </FormGroup>
            </Col>
            <Col xs={3} />
          </Row>
          <Row>
            <Col xs={3} />
            <Col
              xs={6}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <FormGroup
                className='km-formgroup form-field'
                controlId='formHorizontalPassword'>
                <FormControl
                  name='password'
                  className='km-field'
                  type='password'
                  placeholder='Password' />
              </FormGroup>
            </Col>
            <Col xs={3} />
          </Row>
          <Row>
            <Col xs={3} />
            <Col xs={6}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                <input value='Continue' type='submit' id='continue-button' />
              </div>
            </Col>
            <Col xs={3} />
          </Row>
        </Form>
      </div>
    )
  }
};

const mapStateToProps = (store) => ({
  errors: selectors.errors(store)
})
const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)



// WEBPACK FOOTER //
// ./src/Login/form.js